const TableOnlyRowsLoading = ({ cardCount = 3 }) => {
  return (
    <div className="item_loader">
      <div className="table_loader_body">
        {Array.from({ length: cardCount }).map((_, index) => (
          <div key={index} className="table_loader_body_rows" />
        ))}
      </div>
    </div>
  );
};

export default TableOnlyRowsLoading;